<template>
  <div>
    <!-- 热门商品 -->
    <div
      class="hot-product-wrapper"
      v-show="productData.hotRecommendedList.length > 0"
    >
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-black.png" />
        </div>
        <div class="theme-text">精选课堂</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-black.png" />
        </div>
      </div>
      <ul class="hot-product container">
        <li
          v-for="(item, index) in productData.hotRecommendedList.slice(0, 4)"
          :key="index"
        >
          <router-link
            :to="{
              name: item.type === 1 ? 'MajorDetail' : 'CourseDetail',
              params: { id: item.productId },
            }"
          >
            <div class="hot-product-img">
              <div class="can-integral" v-if="item.isIntegral"></div>
              <div class="can-live" v-if="item.hasLive"></div>
              <img :src="getProductCover(1)" />
            </div>
            <div class="hot-product-info">
              <h3>{{ item.name }}</h3>
              <p class="hot-product-teacher">
                授课老师：{{ item.teacherNames }}
              </p>
              <p class="hot-product-teacher">配套配送：</p>
              <div class="hot-product-space">
                <span>送</span>专业老师24小时在线答疑 <br />
                <span>送</span>配套电子课程讲义<br />
                <span>送</span>海量在线题库，在线模拟考试
              </div>
              <div class="hot-product-buy">
                <span class="hot-product-special"
                  >【{{ item.specialName }}】</span
                >
                <span class="hot-product-price">
                  <span
                    v-show="
                      formatPrice(item.discountPrice, item.price)[0] !== '-1'
                    "
                    ><i>￥</i
                    >{{ formatPrice(item.discountPrice, item.price)[0] }}</span
                  >
                  <s
                    v-show="
                      formatPrice(item.discountPrice, item.price)[1] !== '-1'
                    "
                    >￥{{ formatPrice(item.discountPrice, item.price)[1] }}</s
                  >
                </span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 最新上线 -->
    <div
      class="latest-product-wrapper"
      v-show="productData.latestOnlineList.length > 0"
    >
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-white.png" />
        </div>
        <div class="theme-text white">最新上线</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-white.png" />
        </div>
      </div>
      <ul class="latest-product container">
        <li
          v-for="(item, index) in productData.latestOnlineList.slice(0, 3)"
          :key="index"
        >
          <router-link
            :to="{
              name: item.type === 1 ? 'MajorDetail' : 'CourseDetail',
              params: { id: item.productId },
            }"
          >
            <div class="latest-product-img">
              <img :src="getProductCover(1)" />
            </div>
            <div class="latest-product-info">
              <h3>{{ item.name }}</h3>
              <div class="latest-product-buy">
                <span class="product-price">
                  <span
                    v-show="
                      formatPrice(item.discountPrice, item.price)[0] !== '-1'
                    "
                    ><i>￥</i
                    >{{ formatPrice(item.discountPrice, item.price)[0] }}</span
                  >
                  <s
                    v-show="
                      formatPrice(item.discountPrice, item.price)[1] !== '-1'
                    "
                    >￥{{ formatPrice(item.discountPrice, item.price)[1] }}</s
                  >
                </span>
                <span class="product-special">【{{ item.specialName }}】</span>
              </div>
              <div class="can-live" v-if="item.hasLive"></div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 新闻公告 -->
    <div
      class="latest-article-wrapper"
      v-show="productData.newsSectionList.articles.length > 0"
    >
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-white.png" />
        </div>
        <div class="theme-text white">新闻公告</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-white.png" />
        </div>
      </div>
      <div class="latest-article container">
        <div class="latest-article-img">
          <img
            v-if="productData.newsSectionList.image"
            :src="concatImageUrl(productData.newsSectionList.image, 752, 432)"
          />
          <img
            v-else
            src="../../assets/images/theme/synth/latest-article-cover.png"
          />
        </div>
        <ul class="latest-article-list">
          <li
            v-for="(item, index) in productData.newsSectionList.articles.slice(
              0,
              7
            )"
            :key="index"
          >
            <router-link :to="{ name: 'NewsDetail', params: { id: item.id } }">
              <span v-if="index < 3">
                <img
                  src="../../assets/images/theme/synth/latest-article-list-icon.png"
                />
              </span>
              <span v-else> • </span>
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 热门资讯 -->
    <div class="hot-article-wrapper">
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-black.png" />
        </div>
        <div class="theme-text">热门资讯</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-black.png" />
        </div>
      </div>
      <ul
        class="hot-article container"
        v-if="Object.keys(productData.consultationSectionList).length > 0"
      >
        <li>
          <div class="hot-article-bg"></div>
          <div class="hot-article-item">
            <div class="hot-article-title">
              {{ productData.consultationSectionList.name1 }}
            </div>
            <ul class="hot-article-list">
              <li
                v-for="(item, index) in productData.consultationSectionList
                  .leftArticles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: item.id } }"
                  :title="item.title"
                >
                  <span class="dot"></span>
                  <span>{{ item.title }}</span>
                </router-link>
              </li>
              <li
                v-if="
                  productData.consultationSectionList.leftArticles &&
                    productData.consultationSectionList.leftArticles.length >= 8
                "
                style="text-align: right; padding-right: 20px"
              >
                <router-link
                  :to="{
                    name: 'NewsList',
                    params: {
                      id: productData.consultationSectionList.leftCatogoryId
                        ? productData.consultationSectionList.leftCatogoryId
                        : 0,
                    },
                  }"
                  class="news-more"
                  >更多...</router-link
                >
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="hot-article-bg"></div>
          <div class="hot-article-item">
            <div class="hot-article-title">
              {{ productData.consultationSectionList.name2 }}
            </div>
            <ul
              class="hot-article-list"
              v-show="
                productData.consultationSectionList.centerArticles.length > 0
              "
            >
              <li
                v-for="(item, index) in productData.consultationSectionList
                  .centerArticles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: item.id } }"
                  :title="item.title"
                >
                  <span class="dot"></span>
                  <span>{{ item.title }}</span>
                </router-link>
              </li>
              <li
                v-if="
                  productData.consultationSectionList.centerArticles &&
                    productData.consultationSectionList.centerArticles.length >=
                      8
                "
                style="text-align: right; padding-right: 20px"
              >
                <router-link
                  :to="{
                    name: 'NewsList',
                    params: {
                      id: productData.consultationSectionList.centerCatogoryId
                        ? productData.consultationSectionList.centerCatogoryId
                        : 0,
                    },
                  }"
                  class="news-more"
                  >更多...</router-link
                >
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="hot-article-bg"></div>
          <div class="hot-article-item">
            <div class="hot-article-title">
              {{ productData.consultationSectionList.name3 }}
            </div>
            <ul class="hot-article-list">
              <li
                v-for="(item, index) in productData.consultationSectionList
                  .rightArticles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: item.id } }"
                  :title="item.title"
                >
                  <span class="dot"></span>
                  <span>{{ item.title }}</span>
                </router-link>
              </li>
              <li
                v-if="
                  productData.consultationSectionList.rightArticles &&
                    productData.consultationSectionList.rightArticles.length >=
                      8
                "
                style="text-align: right; padding-right: 20px"
              >
                <router-link
                  :to="{
                    name: 'NewsList',
                    params: {
                      id: productData.consultationSectionList.rightCatogoryId
                        ? productData.consultationSectionList.rightCatogoryId
                        : 0,
                    },
                  }"
                  class="news-more"
                  >更多...</router-link
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <!-- 产品列表 -->
    <div
      class="product-wrapper"
      v-for="(item, index) in productData.productCategoryList"
      :key="index"
    >
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-white.png" />
        </div>
        <div class="theme-text white">{{ item.dmTypeName }}</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-white.png" />
        </div>
      </div>

      <div class="product-show container">
        <div class="product-label">
          <div
            class="product-label-item"
            :class="{ selected: item.current && item.current.id === label.id }"
            v-for="(label, labelIndex) in item.dmLables.slice(0, 8)"
            :key="labelIndex"
          >
            <a href="javascript:;">{{ label.lableName }}</a>
            <div class="product-major">
              <a
                href="javascript:;"
                v-for="(major, majorIndex) in label.majorList"
                :key="majorIndex"
                @click="getProductList(item, label, major.MajorID)"
                >{{ major.MajorName }}</a
              >
            </div>
          </div>
          <div class="product-label-item" v-show="item.dmLables.length > 8">
            <router-link
              :to="{ name: 'ProductList', query: { c: item.dmTypeId } }"
              >更多...</router-link
            >
          </div>
        </div>
        <div class="product-box">
          <div class="box-title"></div>
          <div class="box-body">
            <ul class="box-product">
              <li
                v-for="(product, productIndex) in item.productList"
                :key="productIndex"
              >
                <div class="product-item">
                  <router-link
                    :to="{
                      name: product.type === 1 ? 'MajorDetail' : 'CourseDetail',
                      params: { id: product.productId },
                    }"
                  >
                    <div class="product-img">
                      <img :src="getProductCover(2)" />
                      <div class="can-integral" v-if="product.isIntegral"></div>
                      <div class="can-live" v-if="product.hasLive"></div>
                    </div>
                    <div class="product-info">
                      <h3>{{ product.name }}</h3>
                      <div class="product-buy">
                        <span class="product-price">
                          <span
                            v-show="
                              formatPrice(
                                product.discountPrice,
                                product.price
                              )[0] !== '-1'
                            "
                            ><i>￥</i
                            >{{
                              formatPrice(
                                product.discountPrice,
                                product.price
                              )[0]
                            }}</span
                          >
                          <s
                            v-show="
                              formatPrice(
                                product.discountPrice,
                                product.price
                              )[1] !== '-1'
                            "
                            >￥{{
                              formatPrice(
                                product.discountPrice,
                                product.price
                              )[1]
                            }}</s
                          >
                        </span>
                        <span class="product-special"
                          >【{{ product.specialName }}】</span
                        >
                      </div>
                    </div>
                  </router-link>
                </div>
              </li>
            </ul>
            <div class="box-article">
              <ul class="article-cate">
                <li
                  :class="{ selected: !item.active || item.active === 'a' }"
                  @click="changeArticleTab(item, 'a')"
                >
                  <span>{{ item.articles2.title }}</span>
                </li>
                <li
                  :class="{ selected: item.active && item.active === 'b' }"
                  @click="changeArticleTab(item, 'b')"
                >
                  <span>{{ item.articles3.title }}</span>
                </li>
              </ul>
              <div class="article-body">
                <transition name="fade-in">
                  <!-- 12个新闻 -->
                  <ul
                    class="article-list"
                    v-show="!item.active || item.active === 'a'"
                  >
                    <li
                      v-for="(article,
                      articleIndex) in item.articles2.article2List.slice(0, 12)"
                      :key="articleIndex"
                    >
                      <router-link
                        :to="{ name: 'NewsDetail', params: { id: article.id } }"
                      >
                        <span class="dot"></span>
                        <span>{{ article.title }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="item.articles2.article2List.length >= 12"
                      style="text-align: right; padding-right: 14px"
                    >
                      <router-link
                        :to="{
                          name: 'NewsList',
                          params: {
                            id: item.articles2.id ? item.articles2.id : 0,
                          },
                        }"
                        class="news-more"
                        >更多...</router-link
                      >
                    </li>
                  </ul>
                </transition>
                <transition name="fade-in">
                  <ul
                    class="article-list"
                    v-show="item.active && item.active === 'b'"
                  >
                    <li
                      v-for="(article,
                      articleIndex) in item.articles3.article3List.slice(0, 12)"
                      :key="articleIndex"
                    >
                      <router-link
                        :to="{ name: 'NewsDetail', params: { id: article.id } }"
                      >
                        <span class="dot"></span>
                        <span>{{ article.title }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="item.articles3.article3List.length >= 12"
                      style="text-align: right; padding-right: 14px"
                    >
                      <router-link
                        :to="{
                          name: 'NewsList',
                          params: {
                            id: item.articles3.id ? item.articles3.id : 0,
                          },
                        }"
                        class="news-more"
                        >更多...</router-link
                      >
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
          </div>
          <div class="box-footer"></div>
        </div>
      </div>
    </div>

    <!-- 名师推荐 -->
    <div class="teacher-wrapper">
      <div class="theme-title">
        <div class="theme-left">
          <img src="../../assets/images/theme/synth/title-left-white.png" />
        </div>
        <div class="theme-text white">师资团队</div>
        <div class="theme-right">
          <img src="../../assets/images/theme/synth/title-right-white.png" />
        </div>
      </div>

      <div class="teacher-show container">
        <div class="teacher-info">
          <div class="teacher-img">
            <img :src="concatImageUrl(currentTeacher.pic1, 292, 400)" />
          </div>
          <div class="teacher-text">
            <div class="teacher-opacity" ref="teacherI">
              <div class="teacher-name">{{ currentTeacher.tchName }}</div>
              <div class="teacher-intro">{{ currentTeacher.degree }}</div>
              <div class="teacher-item">
                <span>职务职称</span>
                <p v-if="currentTeacher.academy || currentTeacher.position">
                  {{ currentTeacher.academy }} {{ currentTeacher.position }}
                </p>
                <p v-else>讲师</p>
              </div>
              <div class="teacher-item">
                <span>主讲课程</span>
                <p>{{ currentTeacher.courseName }}</p>
              </div>
              <div class="teacher-item">
                <span>教学成果</span>
                <p>{{ currentTeacher.achievement }}</p>
              </div>
            </div>
            <router-link
              :to="{
                name: 'TeacherDetail',
                params: { id: currentTeacher.teacherId },
              }"
              class="teacher-link"
            >
              <b></b>
              <span>
                免费试听<Icon type="md-arrow-dropright" size="20" />
              </span>
            </router-link>
          </div>
        </div>
        <div class="teacher-body">
          <div class="teacher-title">
            <h4>教师团队</h4>
            <p>TEACHER TEAM</p>
            <div class="teacher-tab">
              <a
                class="tab-prev"
                href="javascript:;"
                @click="changeTeacherList(0)"
              >
                <Icon type="md-arrow-dropleft" size="20" />
              </a>
              <a
                class="tab-next"
                href="javascript:;"
                @click="changeTeacherList(1)"
              >
                <Icon type="md-arrow-dropright" size="20" />
              </a>
            </div>
          </div>
          <div class="teacher-content">
            <ul class="teacher-list" ref="teacherA">
              <li
                :class="{
                  selected: item.teacherId === currentTeacher.teacherId,
                }"
                v-for="(item,
                index) in productData.recommendedByFamousTeachers.slice(0, 12)"
                :key="index"
                @click="changeTeacherInfo(item)"
              >
                <img :src="concatImageUrl(item.pic1, 70, 70)" />
              </li>
            </ul>

            <ul class="teacher-list" ref="teacherB">
              <li
                :class="{
                  selected: item.teacherId === currentTeacher.teacherId,
                }"
                v-for="(item,
                index) in productData.recommendedByFamousTeachers.slice(12)"
                :key="index"
                @click="changeTeacherInfo(item)"
              >
                <img :src="concatImageUrl(item.pic1, 70, 70)" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { home } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      teacherTab: 0,
      productData: {
        hotRecommendedList: [],
        latestOnlineList: [],
        newsSectionList: {
          image: "",
          categoryId: 0,
          articles: [],
        },
        consultationSectionList: {},
        productCategoryList: [],
        recommendedByFamousTeachers: [],
      },
      currentTeacher: {},
    };
  },
  mounted() {
    this.getProductData();
    this.productNum = 0;
  },
  methods: {
    getProductData() {
      home.getThemeData(this.siteConfig.agencyId).then((result) => {
        if (result.status === 1) {
          if (result.data.overall) {
            this.productData = result.data.overall;
            //console.log(catagroyList);
            this.productData.productCategoryList.forEach((item) => {
              item.current = item.dmLables[0];
            });
            if (this.productData.recommendedByFamousTeachers.length > 0) {
              this.currentTeacher = this.productData.recommendedByFamousTeachers[0];
            }
          } else {
            this.$Message.error("数据异常3");
          }
        }
      });
    },
    getProductList(item, label, m) {
      //console.log(item, m);
      if (item.majorId == m) return;
      item.majorId = m;
      item.current = label;
      home.getProductList(this.siteConfig.agencyId, m).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          item.productList = res.data.slice(0, 4);
        }
      });
    },
    getProductCover(size) {
      this.productNum++;
      if (this.productNum > 7) this.productNum = 1;
      if (size === 2 && this.productNum > 6) this.productNum = 1;
      let path = "";
      switch (this.productNum) {
        case 1:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-1.png`)
              : require(`../../assets/images/theme/synth/product-1.png`);
          break;
        case 2:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-2.png`)
              : require(`../../assets/images/theme/synth/product-2.png`);
          break;
        case 3:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-3.png`)
              : require(`../../assets/images/theme/synth/product-3.png`);
          break;
        case 4:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-4.png`)
              : require(`../../assets/images/theme/synth/product-4.png`);
          break;
        case 5:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-5.png`)
              : require(`../../assets/images/theme/synth/product-5.png`);
          break;
        case 6:
          path =
            size === 2
              ? require(`../../assets/images/theme/synth/product-sm-6.png`)
              : require(`../../assets/images/theme/synth/product-6.png`);
          break;
        case 7:
          path = require(`../../assets/images/theme/synth/product-7.png`);
          break;
        default:
          size === 2
            ? require(`../../assets/images/theme/synth/product-sm-1.png`)
            : require(`../../assets/images/theme/synth/product-1.png`);
          break;
      }
      return path;
    },
    changeArticleTab(item, tab) {
      this.productNum = 0;
      if (typeof item.active === "undefined") {
        this.$set(item, "active", tab);
      } else {
        item.active = tab;
      }
    },
    changeTeacherList(index) {
      const a = this.$refs.teacherA;
      const b = this.$refs.teacherB;
      if (!a || !b) return;
      let aLeft = 0;
      let bLeft = 0;
      const step = 376;
      let stopStep = 376;
      if (index === 0) {
        if (this.teacherTab === 0) {
          aLeft = 0;
          bLeft = -step;
          this.teacherTab = 1;
        } else if (this.teacherTab === 1) {
          aLeft = -step;
          bLeft = 0;
          this.teacherTab = 0;
        }
        a.style.left = `${aLeft}px`;
        b.style.left = `${bLeft}px`;

        let task = setInterval(() => {
          aLeft += 8;
          bLeft += 8;
          a.style.left = `${aLeft}px`;
          b.style.left = `${bLeft}px`;
          if (
            (this.teacherTab == 1 && bLeft >= 0) ||
            (this.teacherTab == 0 && aLeft >= 0)
          ) {
            clearInterval(task);
          }
        }, 8);
      }
      if (index === 1) {
        if (this.teacherTab === 0) {
          aLeft = 0;
          bLeft = step;
          this.teacherTab = 1;
        } else if (this.teacherTab === 1) {
          aLeft = step;
          bLeft = 0;
          this.teacherTab = 0;
        }
        a.style.left = `${aLeft}px`;
        b.style.left = `${bLeft}px`;

        let task = setInterval(() => {
          aLeft -= 8;
          bLeft -= 8;
          a.style.left = `${aLeft}px`;
          b.style.left = `${bLeft}px`;
          if (
            (this.teacherTab == 1 && bLeft <= 0) ||
            (this.teacherTab == 0 && aLeft <= 0)
          ) {
            clearInterval(task);
          }
        }, 8);
      }
    },
    changeTeacherInfo(item) {
      const i = this.$refs.teacherI;
      i.style.opacity = "0";
      setTimeout(() => {
        i.style.opacity = "1";
      }, 100);
      this.currentTeacher = item;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
.container {
  .can-integral {
    .can-integral();
    left: 0;
    top: 0;
  }
  .can-live {
    .can-live();
    left: -1px;
    bottom: 0;
  }
}
.theme-title {
  padding-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  & > div {
    .inline-block();
  }
  .theme-text {
    font-size: 48px;
    padding: 0 10px;
    font-weight: bold;
    &.white {
      color: #fff;
    }
  }
}
// 热门
.hot-product-wrapper {
  width: 100%;
  background: url("../../assets/images/theme/synth/hot-product-bg.png")
    no-repeat center bottom;
  .theme-title {
    background: url("../../assets/images/theme/synth/hot-product-title-en.png")
      no-repeat center bottom;
  }
  .hot-product {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      position: relative;
      width: 580px;
      margin-bottom: 40px;
      a {
        display: flex;
        color: #333;
      }
      .hot-product-img {
        width: 270px;
        height: 270px;
        position: relative;
        transform-origin: right bottom;
        .transTime(0.3s);
        img {
          position: absolute;
          width: 270px;
          height: 270px;
          right: 0;
          bottom: 0;
        }
      }
      .hot-product-info {
        width: 310px;
        height: 270px;
        padding: 20px;
        background: #fff;
        overflow: hidden;
        box-shadow: 1px 0 5px 1px rgba(0, 0, 0, 0.05);
        .transTime(0.3s);
        h3 {
          font-size: 22px;
          .ellipsis();
        }
        .hot-product-teacher {
          font-size: 14px;
          margin-top: 10px;
          height: 21px;
          .ellipsis();
        }
        .hot-product-space {
          margin-top: 10px;
          height: 90px;
          line-height: 26px;
          span {
            .inline-block();
            width: 18px;
            height: 18px;
            line-height: 18px;
            margin-right: 10px;
            font-size: 10px;
            text-align: center;
            color: #fff;
            background: linear-gradient(
              128.66deg,
              #f86964 10.71%,
              #f88864 92.06%
            );
            border-radius: 20px;
            box-shadow: 0px 2px 4px rgba(249, 110, 101, 0.5);
          }
        }
        .hot-product-buy {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .hot-product-special {
            color: #666;
          }
          .hot-product-price {
            color: #ff6600;
            font-size: 24px;
            i {
              font-style: normal;
              font-size: 14px;
            }
            s {
              margin-left: 6px;
              font-size: 12px;
              color: #808080;
            }
          }
        }
      }
      &:hover {
        .hot-product-img {
          transform: scale(1.1);
        }
        .hot-product-info {
          box-shadow: 1px 0 5px 2px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
//最新上线
.latest-product-wrapper {
  width: 100%;

  background: #192037
    url("../../assets/images/theme/synth/latest-product-bg.png") no-repeat
    center bottom;
  .theme-title {
    background: url("../../assets/images/theme/synth/latest-product-title-en.png")
      no-repeat center bottom;
  }
  .latest-product {
    display: flex;
    justify-content: space-between;
    padding: 50px 0 80px 0;
    li {
      width: 380px;
      .transTime(0.4s);
      .latest-product-img {
        width: 380px;
        height: 380px;
        position: relative;
        z-index: 1;
        img {
          width: 380px;
          height: 380px;
        }
      }
      .latest-product-info {
        width: 320px;
        margin: -40px auto 0 auto;
        background-color: #fff;
        position: relative;
        z-index: 2;
        padding: 16px 16px;
        h3 {
          font-size: 18px;
          color: #333;
          .ellipsis();
          padding-bottom: 10px;
        }
        .latest-product-buy {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .product-special {
            color: #666;
          }
          .product-price {
            color: #ff6600;
            font-size: 24px;
            margin-left: -4px;
            i {
              font-style: normal;
              font-size: 14px;
            }
            s {
              margin-left: 6px;
              font-size: 12px;
              color: #808080;
            }
          }
        }
      }
      &:hover {
        margin-top: -40px;
      }
    }
  }
}
// 最新文章
.latest-article-wrapper {
  width: 100%;
  height: 670px;
  background: #192037
    url("../../assets/images/theme/synth/latest-article-bg.png") no-repeat
    center bottom;
  .theme-title {
    background: url("../../assets/images/theme/synth/latest-article-title-en.png")
      no-repeat center bottom;
  }

  .latest-article {
    display: flex;
    .latest-article-img {
      width: 752px;
      height: 432px;
      overflow: hidden;
      img {
        max-width: 100%;
      }
    }
    .latest-article-list {
      margin-left: 30px;
      border: 3px solid #fff;
      border-bottom: transparent;
      padding: 10px;
      height: 390px;
      li {
        width: 400px;
        .transTime(0.5s);
        background-color: rgba(255, 255, 255, 0);
        a {
          padding: 13px 10px;
          display: block;
          .ellipsis();
        }
        span {
          width: 22px;
          height: 24px;
          text-align: center;
          .inline-block();
          margin-right: 10px;
          font-size: 24px;
          line-height: 24px;
          img {
            margin-top: -2px;
          }
        }
        &:hover {
          background-color: rgba(255, 255, 255, 0.5);
          .transTime(0.05s);
        }
        a {
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
// 热门资讯
.hot-article-wrapper {
  width: 100%;
  margin-top: -50px;
  padding-bottom: 60px;
  background: #fafafa url("../../assets/images/theme/synth/hot-article-bg.png")
    no-repeat top center;
  .theme-title {
    background: url("../../assets/images/theme/synth/hot-article-title-en.png")
      no-repeat center bottom;
  }
  .hot-article {
    display: flex;
    justify-content: space-between;
    & > li {
      position: relative;
      width: 380px;
      height: 480px;
      .transTime(0.4s);
      &:hover {
        margin-top: -30px;
      }
      .hot-article-bg {
        position: absolute;
        width: 320px;
        height: 450px;
        left: 0;
        bottom: 0;
        background: url("../../assets/images/theme/synth/hot-article-body-bg.png")
          no-repeat -10px -5px;
      }
      .hot-article-item {
        position: absolute;
        right: 0;
        top: 0;
        width: 340px;
        height: 450px;
        border-bottom-right-radius: 30px;
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
        background: #fff
          url("../../assets/images/theme/synth/hot-article-footer-bg.png")
          no-repeat center bottom;
        .hot-article-title {
          height: 58px;
          line-height: 58px;
          background: url("../../assets/images/theme/synth/hot-article-title-bg.png")
            no-repeat;
          text-align: center;
          font-size: 24px;
          color: #fff;
        }
        .hot-article-list {
          padding: 20px;
          li {
            width: 310px;
            display: block;
            color: #333;
            padding: 8px 0;
            span {
              .inline-block();
              .ellipsis();
              width: 270px;
              &.dot {
                width: 10px;
                height: 10px;
                border-radius: 10px;
                border: 2px solid #f9d289;
                margin-right: 15px;
                margin-top: -2px;
              }
            }
            a {
              font-size: 15px;
            }
          }
        }
      }
    }
  }
}
// 产品列表
.product-wrapper {
  width: 100%;
  padding-bottom: 80px;
  background: url("../../assets/images/theme/synth/cat-product-bg.png")
    no-repeat center -50px;
  .theme-title {
    background: url("../../assets/images/theme/synth/cat-product-title-en.png")
      no-repeat center bottom;
  }
  .product-show {
    display: flex;
    align-items: flex-start;
    .product-label {
      width: 110px;
      min-height: 300px;
      background: #28355c;
      border-bottom-left-radius: 30px;
      padding-bottom: 30px;
      .product-label-item {
        position: relative;
        & > a {
          display: block;
          height: 56px;
          line-height: 56px;
          text-align: center;
          font-size: 18px;
          color: #fff;
          .ellipsis();
          padding: 0 5px;
        }
        &:hover,
        &.selected {
          & > a {
            background: linear-gradient(to right, #26a2fe, #2280fa);
          }
        }
        &:hover {
          .product-major {
            visibility: visible;
            transform: scale(1);
            opacity: 1;
          }
        }
        .product-major {
          position: absolute;
          left: 110px;
          top: 0;
          width: 360px;
          height: auto;
          background-color: rgba(255, 255, 255, 0.85);
          z-index: 5;
          padding: 10px;
          visibility: hidden;
          transition: 0.25s cubic-bezier(0.24, 0.22, 0.015, 1.56);
          transform: scale(0.8);
          opacity: 0;
          a {
            display: inline-block;
            color: #333;
            font-size: 14px;
            margin: 5px 10px;
            &:hover {
              color: #27a4ff;
            }
          }
        }
      }
    }
    .product-box {
      flex: 1;
      background: #f1f1f1;
      box-shadow: 2px 0 5px 2px rgba(0, 0, 0, 0.1);
      border-bottom-left-radius: 30px;
      position: relative;
      .box-title {
        position: relative;
        width: 100%;
        height: 56px;
        background: #fff
          url("../../assets/images/theme/synth/cat-product-title.png") no-repeat
          right center;
        box-shadow: 1px 0 5px 1px rgba(0, 0, 0, 0.2);
        z-index: 2;
      }
      .box-body {
        display: flex;
        justify-content: space-between;
        position: relative;
        min-height: 500px;
        background: url("../../assets/images/theme/synth/cat-product-body-bg.png")
          no-repeat bottom left;
        z-index: 1;
        padding: 30px;
        .box-product {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          justify-content: space-between;
          width: 630px;
          height: 550px;
          overflow: hidden;
          li {
            width: 300px;
            height: 260px;
            margin-bottom: 30px;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            &:hover {
              .product-item {
                transform: scale(1.02);
              }
            }
            .product-item {
              width: 100%;
              .transTime(0.3s);
            }
            .product-img {
              position: relative;
              width: 300px;
              height: 170px;
              overflow: hidden;
              text-align: center;
              img {
                width: 300px;
                display: inline-block;
              }
            }
            .product-info {
              width: 300px;
              height: 90px;
              overflow: hidden;
              background-color: #fff;
              position: relative;
              z-index: 2;
              padding: 12px 12px;
              h3 {
                font-size: 18px;
                color: #333;
                .ellipsis();
                padding-bottom: 10px;
              }
              .product-buy {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .product-special {
                  color: #666;
                }
                .product-price {
                  color: #ff6600;
                  font-size: 22px;
                  margin-left: -4px;
                  i {
                    font-style: normal;
                    font-size: 14px;
                  }
                  s {
                    margin-left: 6px;
                    font-size: 12px;
                    color: #808080;
                    font-weight: normal;
                  }
                }
              }
            }
          }
        }
        .box-article {
          width: 370px;
          height: 550px;
          overflow: hidden;
          background: #fff
            url("../../assets/images/theme/synth/cat-product-article-bg.png")
            no-repeat top center;
          .article-cate {
            width: 100%;
            height: 60px;
            box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.1);
            padding-top: 20px;
            li {
              display: inline-block;
              padding: 0 10px;
              margin-left: 20px;
              max-width: 45%;
              span {
                display: block;
                width: 100%;
                font-size: 16px;
                padding: 5px 0 2px 0;
                color: #666;
                border-bottom: 2px solid transparent;
                cursor: pointer;
                .ellipsis();
                font-weight: bold;
              }
              &:hover {
                span {
                  color: #27a4ff;
                }
              }
              &.selected {
                span {
                  color: #27a4ff;
                  border-bottom: 2px solid #27a4ff;
                }
              }
            }
          }
          .article-body {
            margin-top: 15px;
            .article-list {
              padding: 0 20px;
              li {
                height: 35px;
                line-height: 35px;
                width: 100%;
                span {
                  .inline-block();
                  .ellipsis();
                  width: calc(100% - 25px);
                  &.dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 10px;
                    border: 2px solid #f9d289;
                    margin-right: 15px;
                  }
                }
                a {
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
      .box-footer {
        position: absolute;
        right: 0;
        bottom: -42px;
        width: 117px;
        height: 42px;
        background: url("../../assets/images/theme/synth/cat-product-footer.png")
          no-repeat;
      }
    }
  }
}
// 名师推荐
.teacher-wrapper {
  width: 100%;
  background: url("../../assets/images/theme/synth/teacher-bg.png") no-repeat
    center -50px;
  .theme-title {
    background: url("../../assets/images/theme/synth/teacher-title-en.png")
      no-repeat center bottom;
  }
  padding-bottom: 60px;
  .teacher-show {
    display: flex;
    align-items: flex-end;
    .teacher-info {
      flex: 1;
      position: relative;
      height: 450px;
      .teacher-img {
        position: relative;
        width: 292px;
        height: 400px;
        background: url("../../assets/images/theme/synth/teacher-avatar-bg.png")
          no-repeat center bottom;
        text-align: center;
        z-index: 2;
        img {
          display: inline-block;
        }
      }
      .teacher-opacity {
        .transTime(0.2s);
      }
      .teacher-text {
        position: absolute;
        left: 50px;
        top: 100px;
        width: 730px;
        height: 350px;
        background: #fff
          url("../../assets/images/theme/synth/teacher-text-bg.png") no-repeat
          right bottom;
        z-index: 1;
        padding-left: 270px;
        .teacher-name {
          font-size: 26px;
          margin-top: 40px;
          font-weight: bold;
        }
        .teacher-intro {
          height: 20px;
          font-size: 16px;
          color: #41a5fd;
          margin-bottom: 30px;
        }
        .teacher-item {
          margin-bottom: 20px;
          span {
            .inline-block();
            width: 80px;
            height: 28px;
            line-height: 28px;
            padding-left: 8px;
            color: #fff;
            background: url("../../assets/images/theme/synth/teacher-btn.png")
              no-repeat;
          }
          p {
            display: inline-block;
            vertical-align: top;
            font-size: 16px;
            margin-left: 10px;
            width: 320px;
            line-height: 32px;
          }
        }
        .teacher-link {
          position: absolute;
          display: block;
          width: 120px;
          height: 40px;
          line-height: 40px;
          color: #fff;
          font-size: 16px;
          text-align: center;
          right: 0;
          top: 50px;
          background: linear-gradient(to right, #247efa, #28a4ff);
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          overflow: hidden;
          .transTime(0.2s);
          b {
            position: absolute;
            display: block;
            width: 120px;
            height: 40px;
            background: linear-gradient(to left, #247efa, #28a4ff);
            z-index: 0;
            opacity: 0;
            .transTime(0.6s);
          }
          span {
            display: inline-block;
            position: relative;
            z-index: 1;
          }

          &:hover {
            box-shadow: 0 0 5px rgba(34, 128, 250, 0.8);
            b {
              opacity: 1;
            }
          }
        }
      }
    }
    .teacher-body {
      width: 376px;
      .teacher-title {
        position: relative;
        padding-left: 20px;
        h4 {
          color: #fff;
          font-size: 26px;
          font-weight: normal;
        }
        p {
          color: #fff;
          font-size: 16px;
          opacity: 0.8;
        }
        .teacher-tab {
          position: absolute;
          bottom: 0;
          right: 0;
          a {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 20px;
            background-color: #565f76;
            margin-left: 20px;
            color: #3d4660;
            &:first-child {
              padding-right: 1px;
            }
            &:last-child {
              padding-left: 1px;
            }
            &:hover {
              background-color: #fff;
            }
          }
        }
      }
      .teacher-content {
        width: 100%;
        height: 282px;
        position: relative;
        overflow: hidden;
        .teacher-list {
          position: absolute;
          top: 0;
          width: 376px;
          display: flex;
          flex-wrap: wrap;
          li {
            margin-left: 20px;
            margin-top: 20px;
            width: 74px;
            height: 74px;
            border: 2px solid transparent;
            cursor: pointer;
            .transTime(0.5s);
            &:hover {
              transform: translateY(-10px);
              .transTime(0.2s);
            }
            &.selected {
              border-color: #38abff;
            }
          }
          &:first-child {
            left: 0;
          }
          &:last-child {
            left: 376px;
          }
        }
      }
    }
  }
}

.news-more {
  color: #999;
  font-size: 12px;
  &:hover {
    color: #57acf6;
  }
}
</style>
